<template>
  <div class="family-selector family-selector__root">
    <div
      v-if="families && families.length === 1 && selectedFamily"
      class="important template-selector-label single"
    >
      {{ selectedFamily | piivoTranslate }}
    </div>
    <div v-else>
      <label v-if="showLabel" class="important template-selector-label multi">{{
        $t('poster.family_selector.label')
      }}</label>
      <pui-common-select
        ref="select"
        :placeholder="$t('poster.family_selector.placeholder')"
        :display="piivoTranslate"
        :options="families"
        :multiple="false"
        :taggable="false"
        :allowGrouping="false"
        :clearable="false"
        :value="selectedFamily"
        @select="selectFamily"
        label=""
        variant="master"
        class="family-selector__select"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'puiFamilySelector',
  props: {
    /**
     * Possible families to select
     */
    families: {
      type: Array,
      required: true,
    },
    /**
     * The current family
     */
    selectedFamily: {
      type: Object,
      default: null,
    },
    /**
     * If the label should be displayed
     */
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    piivoTranslate(value) {
      return Vue.filter('piivoTranslate')(value);
    },
    /**
     * Select a new family.
     * @param {Object} family - Family to select
     */
    selectFamily(family) {
      this.$emit('change', family);
    },
    /**
     * Resets selection
     */
    resetSelection() {
      if (this.$refs.select && this.$refs.select.resetSelection) {
        return this.$refs.select.resetSelection();
      }
      return [];
    },
  },
};
</script>
